export default __webpack_public_path__ + "fonts/poppins-latin-800-normal.a063b644d3c05460f6a2.woff";